import { MapIcon, ModuleConfig } from '@schamburg-web/interfaces';
import {
  AdvancedMarker,
  AdvancedMarkerProps,
  useAdvancedMarkerRef,
  AdvancedMarkerAnchorPoint,
} from '@vis.gl/react-google-maps';
import React from 'react';
import { useMapContext } from '../../contexts/MapContext/MapContext';
import { useModules } from '../../contexts/ModulesContext/ModulesContext';
import { toLatlng } from '../../util/MapUtil';

interface GoogleAdvancedMarkerProps extends AdvancedMarkerProps {
  iconObj: MapIcon;
  module: ModuleConfig;
}

const GoogleAdvancedMarker: React.FC<GoogleAdvancedMarkerProps> = React.memo(
  ({ iconObj, module }) => {
    const [markerRef, marker] = useAdvancedMarkerRef();
    const { selectedMarker, setSelectedMapIcon } = useMapContext();
    const { getStore, getModuleSlice } = useModules();
    const myMarker = module.displayConfig?.markerDef || null;

    // Function to get fresh object data from Redux
    const getFreshIconData = () => {
      const store = getStore();
      const moduleSlice = getModuleSlice(module.name);

      if (!store || !moduleSlice) {
        console.warn(`Could not get fresh data for ${module.name}`);
        return iconObj; // Fallback to original object
      }

      const state = store.getState();
      const displayObjects = moduleSlice.selectors.selectDisplayObjects(state);

      // Find the fresh version of this object
      const freshIcon = displayObjects.find((obj) => obj.id === iconObj.id);

      if (freshIcon) {
        console.log(`Using fresh data for ${module.name} icon ${iconObj.id}`);
        return freshIcon;
      } else {
        console.warn(
          `Could not find fresh data for ${module.name} icon ${iconObj.id}, using original`
        );
        return iconObj; // Fallback if not found
      }
    };

    return (
      <AdvancedMarker
        anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
        position={toLatlng(iconObj)}
        onClick={() => {
          // Get fresh data from Redux when clicked
          const freshIcon = getFreshIconData();

          if (null === selectedMarker) {
            setSelectedMapIcon({ icon: freshIcon, module: module }, marker);
          } else {
            setSelectedMapIcon(null, null);
            setTimeout(() => {
              setSelectedMapIcon({ icon: freshIcon, module: module }, marker);
            }, 100);
          }
        }}
        ref={markerRef}
        zIndex={module.mapConfig.zIndex || 0}
      >
        {myMarker &&
          typeof myMarker === 'function' &&
          React.createElement(myMarker, {
            icon: iconObj,
            key: iconObj.id,
            module: module,
          })}
      </AdvancedMarker>
    );
  }
);

export default GoogleAdvancedMarker;
